module.exports = __webpack_public_path__ + "img/flow.6fb9a0eb.png";